module.exports = __webpack_public_path__ + "static/proizvodi-sa-tezistem-na-prirodnom-porijeklu-sastojaka-ab00db9ba3132fa37e298c07c5904e45.png";